import type { PaginationStateNormalizerConfiguration } from 'services/pagination/typesTS';
import type { UserCollectionsQueryParams } from './types';

const DEFAULT_QUERY = { limit: 45, watched: true };

export const PAGINATION_STATE_NORMALIZER_CONFIGURATION: PaginationStateNormalizerConfiguration<UserCollectionsQueryParams> = {
  initialQuery: DEFAULT_QUERY,
};
